module.exports = {
    clientId: "390537836145-o7hv2vp97a3j1qdeiobg5ct192dpigeg.apps.googleusercontent.com"
}